export var DataImportStatus;
(function (DataImportStatus) {
    DataImportStatus["Complete"] = "complete";
    DataImportStatus["Failed"] = "failed";
    DataImportStatus["Importing"] = "importing";
    DataImportStatus["InitiatingImport"] = "initiatingImport";
    DataImportStatus["NotStarted"] = "notstarted";
    DataImportStatus["Valid"] = "valid";
    DataImportStatus["Validating"] = "validating";
})(DataImportStatus || (DataImportStatus = {}));
//# sourceMappingURL=data-import-status.js.map